import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Email: any;
};

/** Academic Planning settings */
export type AcademicPlanningSettings = {
  __typename?: 'AcademicPlanningSettings';
  enableAcademicPlanning?: Maybe<Scalars['Boolean']>;
};

/** Representation of the active user. */
export type ActiveUser = Node & {
  __typename?: 'ActiveUser';
  /** The ID of an object */
  id: Scalars['ID'];
  /** The active user object */
  user?: Maybe<AdminUser>;
};

export enum AdminAuthProviderType {
  Auth0 = 'AUTH0',
  Cas = 'CAS',
  None = 'NONE'
}

export enum AdminFeatures {
  AccessStudents = 'ACCESS_STUDENTS',
  CartSectionsReports = 'CART_SECTIONS_REPORTS',
  CourseDemandRawData = 'COURSE_DEMAND_RAW_DATA',
  Diagnostics = 'DIAGNOSTICS',
  EnrollmentOptimization = 'ENROLLMENT_OPTIMIZATION',
  EnrollmentOptimizationAdmin = 'ENROLLMENT_OPTIMIZATION_ADMIN',
  ManageEnrollmentBlocks = 'MANAGE_ENROLLMENT_BLOCKS',
  ManageTemplates = 'MANAGE_TEMPLATES',
  ManageUsers = 'MANAGE_USERS',
  PlanningAiAssistant = 'PLANNING_AI_ASSISTANT',
  PlanningCourseDemandData = 'PLANNING_COURSE_DEMAND_DATA',
  PlanCreationData = 'PLAN_CREATION_DATA',
  PreloadStudentCourses = 'PRELOAD_STUDENT_COURSES',
  ReadonlyPlans = 'READONLY_PLANS',
  RegistrationWorksheet = 'REGISTRATION_WORKSHEET',
  SampleStudentLogin = 'SAMPLE_STUDENT_LOGIN',
  StudentSendToCart = 'STUDENT_SEND_TO_CART',
  StudentSendToCartAndRegister = 'STUDENT_SEND_TO_CART_AND_REGISTER',
  StudentUsageRawData = 'STUDENT_USAGE_RAW_DATA',
  StudentUsageReports = 'STUDENT_USAGE_REPORTS',
  ViewAllStudents = 'VIEW_ALL_STUDENTS'
}

/** Admin Customization Center Settings */
export type AdminSettings = {
  __typename?: 'AdminSettings';
  auth0ClientId?: Maybe<Scalars['String']>;
  auth0Domain?: Maybe<Scalars['String']>;
  authProvider?: Maybe<AdminAuthProviderType>;
  disableAdminCreationConfirmationEmail?: Maybe<Scalars['Boolean']>;
  enforceAuthProvider?: Maybe<Scalars['Boolean']>;
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
  providerLoginUrl?: Maybe<Scalars['String']>;
  providerLogoutUrl?: Maybe<Scalars['String']>;
  providerServiceUrlPrefix?: Maybe<Scalars['String']>;
};

/** Representation of admin user data. */
export type AdminUser = Node & {
  __typename?: 'AdminUser';
  /** E-Mail address. */
  email: Scalars['Email'];
  /** Enrollment Optimization Permissions */
  eoPermissions?: Maybe<EoPermissions>;
  /** First name. */
  firstName: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Is user deleted. */
  isDeleted: Scalars['Boolean'];
  /** Is user a super user (Admin). */
  isSuperUser: Scalars['Boolean'];
  /** Last name. */
  lastName: Scalars['String'];
  /** pre-migration legacy admin user id */
  legacyAdminUserId?: Maybe<Scalars['Int']>;
  /** Permissions. */
  permissions?: Maybe<Array<Maybe<AdminFeatures>>>;
};

/** A connection to a list of items. */
export type AdminUserConnection = {
  __typename?: 'AdminUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdminUserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of admin users matched by search */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AdminUserEdge = {
  __typename?: 'AdminUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AdminUser>;
};

/** Representation of admin user data. */
export type AdminUserOutput = {
  __typename?: 'AdminUserOutput';
  /** E-Mail address. */
  email?: Maybe<Scalars['String']>;
  /** Enrollment Optimization Permissions */
  eoPermissions?: Maybe<EoPermissions>;
  /** First name. */
  firstName?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Is user deleted. */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Is user a super user (Admin). */
  isSuperUser?: Maybe<Scalars['Boolean']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']>;
  /** pre-migration legacy admin user id */
  legacyAdminUserId?: Maybe<Scalars['Int']>;
  /** Permissions. */
  permissions?: Maybe<Array<Maybe<AdminFeatures>>>;
};

export type ConfirmAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmToken: Scalars['String'];
  environment: Scalars['String'];
  password: Scalars['String'];
  type: Scalars['String'];
};

export type ConfirmAdminUserPayload = {
  __typename?: 'ConfirmAdminUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
};

/** A course. */
export type Course = Node & {
  __typename?: 'Course';
  /** Course Description */
  catalogDescription?: Maybe<Scalars['String']>;
  /** Course Component */
  component?: Maybe<Scalars['String']>;
  /** Course ID */
  courseId?: Maybe<Scalars['String']>;
  /** Course Title */
  hasTopics?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Course Maximum Units */
  maximumUnits?: Maybe<Scalars['Int']>;
  /** Course Minimum Units */
  minimumUnits?: Maybe<Scalars['Int']>;
  /** Course Number */
  number?: Maybe<Scalars['String']>;
  /** The parent subject */
  subject?: Maybe<Subject>;
  /** Course Subject ID */
  subjectId?: Maybe<Scalars['String']>;
  /** Course Subject Name */
  subjectName?: Maybe<Scalars['String']>;
  /** Course Subject Long Name */
  subjectNameLong?: Maybe<Scalars['String']>;
  /** Course Term Name */
  term?: Maybe<Scalars['String']>;
  /** Course Term Name */
  termCode?: Maybe<Scalars['String']>;
  /** Course Title */
  title?: Maybe<Scalars['String']>;
  /** Course Long Title */
  titleLong?: Maybe<Scalars['String']>;
  /** Get topics by Course. */
  topics?: Maybe<TopicConnection>;
};


/** A course. */
export type CourseTopicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type CourseConnection = {
  __typename?: 'CourseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CourseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Course lookup criteria */
export type CourseCriteria = {
  /** course number */
  courseNumber: Scalars['String'];
  /** subject id */
  subjectId: Scalars['String'];
};

/** An edge in a connection. */
export type CourseEdge = {
  __typename?: 'CourseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Course>;
};

/** Course Search Customization Center Settings */
export type CourseSearchSettings = {
  __typename?: 'CourseSearchSettings';
  courseFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  courseSearchFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  dropDownOptionsLimit?: Maybe<Scalars['Int']>;
  footerEntries?: Maybe<Array<Maybe<Scalars['String']>>>;
  headerLinks?: Maybe<Array<Maybe<LinkSettings>>>;
  plannerLinkText?: Maybe<Scalars['String']>;
  searchPlaceholder?: Maybe<Scalars['String']>;
  sectionFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  sectionFooterEntries?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Course Customization Center Settings */
export type CourseSettings = {
  __typename?: 'CourseSettings';
  topicsEnabled?: Maybe<Scalars['Boolean']>;
};

/** enumeration of days of week */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteAdminUserPayload = {
  __typename?: 'DeleteAdminUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAdminUserId: Scalars['ID'];
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
};

/** Logs For Diagnostics */
export type DiagnosticLogs = {
  __typename?: 'DiagnosticLogs';
  endDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export enum DiagnosticsLogType {
  Catalog = 'Catalog',
  EmptyOpenSeat = 'EmptyOpenSeat',
  OpenSeat = 'OpenSeat',
  Other = 'Other',
  Schedule = 'Schedule'
}

/** An environment. */
export type Environment = Node & {
  __typename?: 'Environment';
  /** Enabled admin features. */
  adminFeatures?: Maybe<Array<Maybe<AdminFeatures>>>;
  /** Get a single admin user by id or email. */
  adminUser?: Maybe<AdminUser>;
  /** Get admin users */
  adminUsers?: Maybe<AdminUserConnection>;
  /** Get all available terms */
  courseSearchTerms?: Maybe<Array<Maybe<SearchTerm>>>;
  /** Get Diagnostic Logs. */
  diagnosticLogs?: Maybe<PagedResultDiagnosticsLogs>;
  /** Find courses */
  findCourses?: Maybe<SearchCourseConnection>;
  /** Generate Schedules */
  generateSchedules?: Maybe<ScheduleGenResponse>;
  /** Get sections for a course */
  getCourseSections?: Maybe<SearchSectionConnection>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Environment name */
  name: Scalars['String'];
  /** Get preloader history */
  preloaderHistory?: Maybe<PreloaderHistoryConnection>;
  /** Get public settings */
  publicSettings?: Maybe<PublicSettings>;
  /** Get reporting terms. */
  reportTerms?: Maybe<ReportTermConnection>;
  /** Get settings */
  settings?: Maybe<Settings>;
  /** Get student usage data */
  studentUsage?: Maybe<StudentUsage>;
  /** Subdomain of environment */
  subdomain: Scalars['String'];
  /** Get type ahead course suggestions */
  suggestCourses?: Maybe<Array<Maybe<SearchSuggestResultCourse>>>;
  /** Get terms. */
  term?: Maybe<Term>;
  /** Get terms. */
  terms?: Maybe<TermConnection>;
  /** Get unconfirmed admin user */
  unconfirmedAdminUser?: Maybe<UnconfirmedAdminUser>;
};


/** An environment. */
export type EnvironmentAdminUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['Int']>;
};


/** An environment. */
export type EnvironmentAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  confirmToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  isSuperUser?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  nameEmailFilter?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


/** An environment. */
export type EnvironmentDiagnosticLogsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  logTypes?: InputMaybe<Array<InputMaybe<DiagnosticsLogType>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


/** An environment. */
export type EnvironmentFindCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  careers?: InputMaybe<Scalars['String']>;
  courseTypeDescription?: InputMaybe<Scalars['String']>;
  facets?: InputMaybe<Array<InputMaybe<SearchFacetCriteria>>>;
  first?: InputMaybe<Scalars['Int']>;
  freeTextbook?: InputMaybe<Scalars['Boolean']>;
  includeFullCourses?: InputMaybe<Scalars['Boolean']>;
  instructor?: InputMaybe<Scalars['String']>;
  lowCostTextbook?: InputMaybe<Scalars['Boolean']>;
  partsOfTerm?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  termCode: Scalars['String'];
};


/** An environment. */
export type EnvironmentGenerateSchedulesArgs = {
  breaks?: InputMaybe<Array<InputMaybe<ScheduleGenBreak>>>;
  courses?: InputMaybe<Array<InputMaybe<CourseCriteria>>>;
  termCode: Scalars['String'];
};


/** An environment. */
export type EnvironmentGetCourseSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  careers?: InputMaybe<Scalars['String']>;
  courseId: Scalars['ID'];
  facets?: InputMaybe<Array<InputMaybe<SearchFacetCriteria>>>;
  first?: InputMaybe<Scalars['Int']>;
  freeTextbook?: InputMaybe<Scalars['Boolean']>;
  includeFullSections?: InputMaybe<Scalars['Boolean']>;
  instructor?: InputMaybe<Scalars['String']>;
  lowCostTextbook?: InputMaybe<Scalars['Boolean']>;
  partsOfTerm?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
};


/** An environment. */
export type EnvironmentPreloaderHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortDesc?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<Scalars['String']>;
};


/** An environment. */
export type EnvironmentReportTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** An environment. */
export type EnvironmentStudentUsageArgs = {
  year?: InputMaybe<Scalars['Int']>;
};


/** An environment. */
export type EnvironmentSuggestCoursesArgs = {
  prefix: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  termCode: Scalars['String'];
};


/** An environment. */
export type EnvironmentTermArgs = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


/** An environment. */
export type EnvironmentTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** An environment. */
export type EnvironmentUnconfirmedAdminUserArgs = {
  confirmToken: Scalars['String'];
};

/** Admin User Enrollment Optimization Permissions */
export type EoPermissions = {
  __typename?: 'EoPermissions';
  /** Flag indicating whether admin user has access to all EO campuses */
  allCampuses: Scalars['Boolean'];
  /** Flag indicating whether admin user has access to all EO subjects */
  allSubjects: Scalars['Boolean'];
  /** List of EO campus codes admin user has access to */
  campusCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of EO subject ids admin user has access to */
  subjectIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Filter Customization Center Settings */
export type FilterSettings = {
  __typename?: 'FilterSettings';
  campusSelectionPrefixes?: Maybe<Scalars['String']>;
};

/** Course settings flag */
export type Flag = {
  __typename?: 'Flag';
  hideOnCourse?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  sectionText?: Maybe<Scalars['String']>;
  sectionTooltip?: Maybe<Scalars['String']>;
  showOnSection?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
};

/** Help Link Settings */
export type HelpLink = {
  __typename?: 'HelpLink';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Help settings and custom links */
export type HelpSettings = {
  __typename?: 'HelpSettings';
  links?: Maybe<Array<Maybe<HelpLink>>>;
  videos?: Maybe<Array<Maybe<HelpVideo>>>;
};

/** Help Video Settings */
export type HelpVideo = {
  __typename?: 'HelpVideo';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  skillLevel?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InsertAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  eoAllCampuses?: InputMaybe<Scalars['Boolean']>;
  eoAllSubjects?: InputMaybe<Scalars['Boolean']>;
  eoCampusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eoSubjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  permissions?: InputMaybe<Array<InputMaybe<AdminFeatures>>>;
};

export type InsertAdminUserPayload = {
  __typename?: 'InsertAdminUserPayload';
  adminUser?: Maybe<AdminUserOutput>;
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
};

export type InsertSsoAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  eoAllCampuses?: InputMaybe<Scalars['Boolean']>;
  eoAllSubjects?: InputMaybe<Scalars['Boolean']>;
  eoCampusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eoSubjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  permissions?: InputMaybe<Array<InputMaybe<AdminFeatures>>>;
};

export type InsertSsoAdminUserPayload = {
  __typename?: 'InsertSsoAdminUserPayload';
  adminUser?: Maybe<AdminUserOutput>;
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
};

/** Link Settings */
export type LinkSettings = {
  __typename?: 'LinkSettings';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum LocationFormatType {
  Building = 'Building',
  BuildingAndRoom = 'BuildingAndRoom',
  BuildingCode = 'BuildingCode',
  BuildingCodeAndRoom = 'BuildingCodeAndRoom',
  BuildingDescriptionAndRoom = 'BuildingDescriptionAndRoom',
  CampusBuildingCodeAndRoom = 'CampusBuildingCodeAndRoom',
  Room = 'Room'
}

/** Mutation Error result */
export type MutationError = {
  __typename?: 'MutationError';
  /** Error Messages */
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Status Code */
  statusCode?: Maybe<Scalars['Int']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PagedResultDiagnosticsLogs = {
  __typename?: 'PagedResultDiagnosticsLogs';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  resultCount: Scalars['Int'];
  results?: Maybe<Array<Maybe<DiagnosticLogs>>>;
  sortKey: Scalars['String'];
  sortOrder: Scalars['String'];
};

export type PreloadRevertInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the preload history to be reverted */
  historyId?: InputMaybe<Scalars['Int']>;
};

export type PreloadRevertPayload = {
  __typename?: 'PreloadRevertPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
  preloaderHistory?: Maybe<PreloaderHistory>;
};

export type PreloadStudentsInput = {
  breaks: Array<InputMaybe<PreloaderBreakInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  courses: Array<InputMaybe<PreloaderCourseInput>>;
  notes?: InputMaybe<Scalars['String']>;
  /** List of student IDs */
  studentIds: Array<InputMaybe<Scalars['String']>>;
  /** Term description matching termId input field */
  term: Scalars['String'];
  termId: Scalars['ID'];
};

export type PreloadStudentsPayload = {
  __typename?: 'PreloadStudentsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
  preloaderHistory?: Maybe<PreloaderHistory>;
};

/** Scheduled break */
export type PreloaderBreak = {
  __typename?: 'PreloaderBreak';
  /** Break is on Monday */
  daysOfWeek?: Maybe<Array<Maybe<DaysOfWeek>>>;
  /** End Hour, 24-hour format */
  endHour: Scalars['Int'];
  /** End Minute */
  endMinute: Scalars['Int'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Break Name */
  name: Scalars['String'];
  /** Start Hour, 24-hour format */
  startHour: Scalars['Int'];
  /** Start Minute */
  startMinute: Scalars['Int'];
};

export type PreloaderBreakInput = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<DaysOfWeek>>>;
  endHour: Scalars['Int'];
  endMinute: Scalars['Int'];
  name: Scalars['String'];
  startHour: Scalars['Int'];
  startMinute: Scalars['Int'];
};

/** Preloader Course */
export type PreloaderCourse = {
  __typename?: 'PreloaderCourse';
  /** Course Identifier Unique To Schedule Planner (Not SIS) */
  courseId?: Maybe<Scalars['Int']>;
  /** Course Number */
  courseNumber: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Is this course required */
  required: Scalars['Boolean'];
  /** Courses Subject */
  subject: Scalars['String'];
  /** Course Title */
  title: Scalars['String'];
  /** Topic Description */
  topicDescription?: Maybe<Scalars['String']>;
  /** Topic Identifier */
  topicId?: Maybe<Scalars['Int']>;
};

export type PreloaderCourseInput = {
  courseNumber: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  subjectId: Scalars['String'];
  title: Scalars['String'];
  topicDescription?: InputMaybe<Scalars['String']>;
  topicId?: InputMaybe<Scalars['String']>;
};

/** A preloader history object. */
export type PreloaderHistory = Node & {
  __typename?: 'PreloaderHistory';
  /** Breaks */
  breaks?: Maybe<Array<Maybe<PreloaderBreak>>>;
  /** Courses */
  courses?: Maybe<Array<Maybe<PreloaderCourse>>>;
  /** Date preloading took place. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** History ID */
  historyId: Scalars['Int'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Notes */
  notes: Scalars['String'];
  /** Flag indicating whether this preloader operation has been reverted */
  reverted?: Maybe<Scalars['Boolean']>;
  /** Date/time this preloader operation was reverted */
  revertedAt?: Maybe<Scalars['DateTime']>;
  /** Admin user that reverted this preloader operation */
  revertedBy?: Maybe<AdminUser>;
  /** Number of student IDs  */
  studentIdCount: Scalars['Int'];
  /** Term */
  term: Scalars['String'];
  /** Term Code */
  termCode: Scalars['String'];
  /** User that ran the preloader */
  user?: Maybe<AdminUser>;
};

/** A connection to a list of items. */
export type PreloaderHistoryConnection = {
  __typename?: 'PreloaderHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PreloaderHistoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PreloaderHistoryEdge = {
  __typename?: 'PreloaderHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PreloaderHistory>;
};

/** Public Course Customization Center Settings */
export type PublicCourseSettings = {
  __typename?: 'PublicCourseSettings';
  flags?: Maybe<Array<Maybe<Flag>>>;
};

/** A term (like quarter, trimester or semester) found in reports. */
export type ReportTerm = Node & {
  __typename?: 'ReportTerm';
  /** Active term */
  active?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Term name */
  name?: Maybe<Scalars['String']>;
  /** Term Id */
  termId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type ReportTermConnection = {
  __typename?: 'ReportTermConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportTermEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportTermEdge = {
  __typename?: 'ReportTermEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTerm>;
};

export type ResetAdminUserPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  environment: Scalars['String'];
};

export type ResetAdminUserPasswordPayload = {
  __typename?: 'ResetAdminUserPasswordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
};

/** Root for mutation operations. */
export type RootMutation = {
  __typename?: 'RootMutation';
  /** Confirms an admin user (sets password) */
  confirmAdminUser?: Maybe<ConfirmAdminUserPayload>;
  /** Delete admin user */
  deleteAdminUser?: Maybe<DeleteAdminUserPayload>;
  /** Insert adminm user */
  insertAdminUser?: Maybe<InsertAdminUserPayload>;
  /** Insert SSO admin user */
  insertSsoAdminUser?: Maybe<InsertSsoAdminUserPayload>;
  /** Revert the preload */
  preloadRevert?: Maybe<PreloadRevertPayload>;
  /** Preload students with courses and breaks */
  preloadStudents?: Maybe<PreloadStudentsPayload>;
  /** Reset admin user password */
  resetAdminUserPassword?: Maybe<ResetAdminUserPasswordPayload>;
  /** Update admin user */
  updateAdminUser?: Maybe<UpdateAdminUserPayload>;
  /** Updates current user email, name, and password */
  updateProfile?: Maybe<UpdateProfilePayload>;
  /** Upload student IDs List */
  uploadStudentIds?: Maybe<UploadStudentIdsPayload>;
};


/** Root for mutation operations. */
export type RootMutationConfirmAdminUserArgs = {
  input: ConfirmAdminUserInput;
};


/** Root for mutation operations. */
export type RootMutationDeleteAdminUserArgs = {
  input: DeleteAdminUserInput;
};


/** Root for mutation operations. */
export type RootMutationInsertAdminUserArgs = {
  input: InsertAdminUserInput;
};


/** Root for mutation operations. */
export type RootMutationInsertSsoAdminUserArgs = {
  input: InsertSsoAdminUserInput;
};


/** Root for mutation operations. */
export type RootMutationPreloadRevertArgs = {
  input: PreloadRevertInput;
};


/** Root for mutation operations. */
export type RootMutationPreloadStudentsArgs = {
  input: PreloadStudentsInput;
};


/** Root for mutation operations. */
export type RootMutationResetAdminUserPasswordArgs = {
  input: ResetAdminUserPasswordInput;
};


/** Root for mutation operations. */
export type RootMutationUpdateAdminUserArgs = {
  input: UpdateAdminUserInput;
};


/** Root for mutation operations. */
export type RootMutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


/** Root for mutation operations. */
export type RootMutationUploadStudentIdsArgs = {
  input: UploadStudentIdsInput;
};

/** Root for query operations. */
export type RootQuery = {
  __typename?: 'RootQuery';
  /** Get active environment. */
  environment?: Maybe<Environment>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Information about the currently logged in user. */
  viewer?: Maybe<ActiveUser>;
};


/** Root for query operations. */
export type RootQueryEnvironmentArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/** Root for query operations. */
export type RootQueryNodeArgs = {
  id: Scalars['ID'];
};

/** Break */
export type ScheduleGenBreak = {
  meetingPatterns?: InputMaybe<Array<InputMaybe<ScheduleGenMeetingPatternInput>>>;
  name: Scalars['String'];
};

/** Hydrated course view, with registration blocks */
export type ScheduleGenCourse = {
  __typename?: 'ScheduleGenCourse';
  courseNumber: Scalars['String'];
  registrationBlocks?: Maybe<Array<Maybe<ScheduleGenRegBlock>>>;
  subjectCode: Scalars['String'];
};

/** Meeting Pattern */
export type ScheduleGenMeetingPattern = {
  __typename?: 'ScheduleGenMeetingPattern';
  days?: Maybe<Array<Maybe<DayOfWeek>>>;
  endDate?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['Int'];
};

/** Meeting Pattern Input */
export type ScheduleGenMeetingPatternInput = {
  days?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['Int'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  startTime: Scalars['Int'];
};

/** Association of regisrtation numbers and a set of meeting patterns */
export type ScheduleGenRegBlock = {
  __typename?: 'ScheduleGenRegBlock';
  meetingPatterns?: Maybe<Array<Maybe<ScheduleGenMeetingPattern>>>;
  registrationNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Schedule Generation Response */
export type ScheduleGenResponse = {
  __typename?: 'ScheduleGenResponse';
  /** Hydrated courses with registration blocks, lookup for reg numbers in returned schedules */
  courses?: Maybe<Array<Maybe<ScheduleGenCourse>>>;
  /** List of valid registration number combinations */
  schedules?: Maybe<Array<Maybe<ScheduleGenSchedule>>>;
};

/** Wrapper for a list of non-conflicting registraiton numbers */
export type ScheduleGenSchedule = {
  __typename?: 'ScheduleGenSchedule';
  registrationNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Search Course */
export type SearchCourse = Node & {
  __typename?: 'SearchCourse';
  /** Course Number */
  courseNumber?: Maybe<Scalars['String']>;
  /** Course-Level Maximum Credits */
  creditsMax?: Maybe<Scalars['Float']>;
  /** Course-Level Minimum Credits */
  creditsMin?: Maybe<Scalars['Float']>;
  /** Course Description */
  description?: Maybe<Scalars['String']>;
  /** External Course Id */
  externalCourseId?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Course Subject */
  subject?: Maybe<SearchSubject>;
  /** Term */
  term?: Maybe<SearchTerm>;
  /** Course Title */
  title?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type SearchCourseConnection = {
  __typename?: 'SearchCourseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchCourseEdge>>>;
  /** Course search facet results */
  facetFieldResults?: Maybe<Array<Maybe<SearchFacetFieldResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of sections matched by search */
  totalSections: Scalars['Int'];
};

/** An edge in a connection. */
export type SearchCourseEdge = {
  __typename?: 'SearchCourseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchCourse>;
};

/** course search request criteria regarding facets */
export type SearchFacetCriteria = {
  /** should we return up to 1000 buckets instead of the default 10 for this facet field? */
  expandedBuckets?: InputMaybe<Scalars['Boolean']>;
  /** facet field */
  facetField: SearchFacetField;
  /** selected facet values filters */
  selectedFilterValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** enumeration of facet field types */
export enum SearchFacetField {
  Campus = 'CAMPUS',
  Careers = 'CAREERS',
  CourseTypeDescription = 'COURSE_TYPE_DESCRIPTION',
  InstructionMode = 'INSTRUCTION_MODE',
  Instructor = 'INSTRUCTOR',
  Location = 'LOCATION',
  PartsOfTerm = 'PARTS_OF_TERM'
}

/** Course search result facet information */
export type SearchFacetFieldResult = {
  __typename?: 'SearchFacetFieldResult';
  /** facet field */
  facetField: SearchFacetField;
  /** values and counts for the facet field type */
  facetFieldValueResults?: Maybe<Array<Maybe<SearchFacetFieldValueResult>>>;
  /** flag indicating whether this facet field result has more buckets available */
  hasMoreBuckets: Scalars['Boolean'];
};

/** result metadata for a specific facet field type and for a specific value */
export type SearchFacetFieldValueResult = {
  __typename?: 'SearchFacetFieldValueResult';
  /** number of results for this facet field with this value */
  sectionCount: Scalars['Int'];
  /** flag indicating whether this facet was selected in the current search operation */
  selected: Scalars['Boolean'];
  /** facet value */
  value: Scalars['String'];
};

/** Search Section */
export type SearchSection = Node & {
  __typename?: 'SearchSection';
  /** Campus */
  campus?: Maybe<Scalars['String']>;
  /** Careers */
  careers?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Section Component (lab, lecture, etc) */
  component?: Maybe<Scalars['String']>;
  /** Course Offer Number */
  courseOfferNumber?: Maybe<Scalars['String']>;
  /** Course Type Description */
  courseTypeDescription?: Maybe<Scalars['String']>;
  /** Section-Level Maximum Credits */
  creditsMax?: Maybe<Scalars['Float']>;
  /** Section-Level Minimum Credits */
  creditsMin?: Maybe<Scalars['Float']>;
  /** Date instruction ends */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Free Textbook available flag */
  freeTextbookAvailable?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Instruction Mode */
  instructionMode?: Maybe<Scalars['String']>;
  /** Instructors */
  instructors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Location */
  location?: Maybe<Scalars['String']>;
  /** Low Cost Textbook available flag */
  lowCostTextbookAvailable?: Maybe<Scalars['Boolean']>;
  /** Section Meetings */
  meetings?: Maybe<Array<Maybe<SearchSectionMeeting>>>;
  /** Available seats */
  openSeats?: Maybe<Scalars['Int']>;
  /** Parts Of Term */
  partsOfTerm?: Maybe<Scalars['String']>;
  /** Registration Number */
  registrationNumber: Scalars['String'];
  /** Section Number */
  sectionNumber?: Maybe<Scalars['String']>;
  /** Date instruction starts */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Total seats */
  totalSeats?: Maybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type SearchSectionConnection = {
  __typename?: 'SearchSectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchSectionEdge>>>;
  /** Course sections facet results */
  facetFieldResults?: Maybe<Array<Maybe<SearchFacetFieldResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of sections matched by search */
  totalSections: Scalars['Int'];
};

/** An edge in a connection. */
export type SearchSectionEdge = {
  __typename?: 'SearchSectionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchSection>;
};

/** Search Section Meeting */
export type SearchSectionMeeting = {
  __typename?: 'SearchSectionMeeting';
  /** Building */
  building?: Maybe<Scalars['String']>;
  /** Building Code */
  buildingCode?: Maybe<Scalars['String']>;
  /** Building Description */
  buildingDescription?: Maybe<Scalars['String']>;
  /** Meeting days */
  days?: Maybe<Scalars['String']>;
  /** Meeting end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Meeting end time */
  endTime?: Maybe<Scalars['Int']>;
  /** Room */
  room?: Maybe<Scalars['String']>;
  /** Meeting start date */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Meeting start time */
  startTime?: Maybe<Scalars['Int']>;
};

/** Search Subject */
export type SearchSubject = {
  __typename?: 'SearchSubject';
  /** Subject ID */
  id: Scalars['String'];
  /** Long name */
  longName?: Maybe<Scalars['String']>;
  /** Short name */
  shortName?: Maybe<Scalars['String']>;
};

/** Course Suggestion Result */
export type SearchSuggestResultCourse = {
  __typename?: 'SearchSuggestResultCourse';
  /** Course ID used to retrieve the singular course represented by this suggestion */
  courseId: Scalars['ID'];
  /** Course Number */
  courseNumber: Scalars['String'];
  /** Subject ID */
  subjectId: Scalars['String'];
  /** Course Title */
  title: Scalars['String'];
};

/** Search Term */
export type SearchTerm = Node & {
  __typename?: 'SearchTerm';
  /** Term Code */
  code: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Term Name */
  name: Scalars['String'];
};

/** Section Field Text Customization Center Settings */
export type SectionFieldTextSettings = {
  __typename?: 'SectionFieldTextSettings';
  campus?: Maybe<Scalars['String']>;
  campusPlural?: Maybe<Scalars['String']>;
  careers?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  dates?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['String']>;
  freeTextbookIndicated?: Maybe<Scalars['String']>;
  instructionMode?: Maybe<Scalars['String']>;
  instructor?: Maybe<Scalars['String']>;
  instructorPlural?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  lowCostTextbookIndicated?: Maybe<Scalars['String']>;
  meetings?: Maybe<Scalars['String']>;
  openSeats?: Maybe<Scalars['String']>;
  partsOfTerm?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['String']>;
  times?: Maybe<Scalars['String']>;
};

/** Section Customization Center Settings */
export type SectionSettings = {
  __typename?: 'SectionSettings';
  locationFormat?: Maybe<LocationFormatType>;
};

/** Security Customization Center Settings */
export type SecuritySettings = {
  __typename?: 'SecuritySettings';
  passwordMinimumLength?: Maybe<Scalars['Int']>;
  passwordMinimumLowercase?: Maybe<Scalars['Int']>;
  passwordMinimumNumeric?: Maybe<Scalars['Int']>;
  passwordMinimumSpecialCharacters?: Maybe<Scalars['Int']>;
  passwordMinimumUppercase?: Maybe<Scalars['Int']>;
};

/** SIS Settings */
export type SisSettings = {
  __typename?: 'SisSettings';
  liveRegistration?: Maybe<Scalars['Boolean']>;
};

/** Wrapper for student usage data */
export type StudentUsage = {
  __typename?: 'StudentUsage';
  /** data */
  monthly?: Maybe<Array<Maybe<StudentUsageMonthlyAggregate>>>;
};

/** Monthly usage statistic */
export type StudentUsageMonthlyAggregate = {
  __typename?: 'StudentUsageMonthlyAggregate';
  /** Total logins */
  logins?: Maybe<Scalars['Int']>;
  /** Month */
  month?: Maybe<Scalars['String']>;
  /** New user count */
  users?: Maybe<Scalars['Int']>;
  /** Year */
  year?: Maybe<Scalars['Int']>;
};

/** Style Customization Center Settings */
export type StyleSettings = {
  __typename?: 'StyleSettings';
  freeTextbookFlagColor?: Maybe<Scalars['String']>;
  freeTextbookImageFileName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  lowCostTextbookFlagColor?: Maybe<Scalars['String']>;
  lowCostTextbookImageFileName?: Maybe<Scalars['String']>;
  navbarColor?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

/** A subject. */
export type Subject = Node & {
  __typename?: 'Subject';
  /** Get courses for subject. */
  courses?: Maybe<CourseConnection>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Subject ID */
  subjectId?: Maybe<Scalars['String']>;
  /** Subject Name */
  subjectName?: Maybe<Scalars['String']>;
  /** Subject Long Name */
  subjectNameLong?: Maybe<Scalars['String']>;
};


/** A subject. */
export type SubjectCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type SubjectConnection = {
  __typename?: 'SubjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubjectEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SubjectEdge = {
  __typename?: 'SubjectEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Subject>;
};

/** A term (like quarter, trimester or semester). */
export type Term = Node & {
  __typename?: 'Term';
  /** Term code */
  code?: Maybe<Scalars['String']>;
  /** Get a single course */
  course?: Maybe<Course>;
  /** Get courses for term. */
  courses?: Maybe<CourseConnection>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Term name */
  name?: Maybe<Scalars['String']>;
  /** Get subject. */
  subject?: Maybe<Subject>;
  /** Get subjects. */
  subjects?: Maybe<SubjectConnection>;
};


/** A term (like quarter, trimester or semester). */
export type TermCourseArgs = {
  courseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  number?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['String']>;
};


/** A term (like quarter, trimester or semester). */
export type TermCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};


/** A term (like quarter, trimester or semester). */
export type TermSubjectArgs = {
  subjectId: Scalars['String'];
};


/** A term (like quarter, trimester or semester). */
export type TermSubjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortDesc?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type TermConnection = {
  __typename?: 'TermConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TermEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TermEdge = {
  __typename?: 'TermEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Term>;
};

/** Text Customization Center Settings */
export type TextSettings = {
  __typename?: 'TextSettings';
  academicCareerPlural?: Maybe<Scalars['String']>;
  campus?: Maybe<Scalars['String']>;
  campusPlural?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  coursePlural?: Maybe<Scalars['String']>;
  courseStatus?: Maybe<Scalars['String']>;
  freeTextbook?: Maybe<Scalars['String']>;
  freeTextbookInstructions?: Maybe<Scalars['String']>;
  fridayAbbr?: Maybe<Scalars['String']>;
  instructionMode?: Maybe<Scalars['String']>;
  instructionModePlural?: Maybe<Scalars['String']>;
  instructor?: Maybe<Scalars['String']>;
  instructorPlural?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  locationPlural?: Maybe<Scalars['String']>;
  mondayAbbr?: Maybe<Scalars['String']>;
  partsOfTermPlural?: Maybe<Scalars['String']>;
  saturdayAbbr?: Maybe<Scalars['String']>;
  sectionPlural?: Maybe<Scalars['String']>;
  sessionPlural?: Maybe<Scalars['String']>;
  sundayAbbr?: Maybe<Scalars['String']>;
  thursdayAbbr?: Maybe<Scalars['String']>;
  tuesdayAbbr?: Maybe<Scalars['String']>;
  universityTitle?: Maybe<Scalars['String']>;
  wednesdayAbbr?: Maybe<Scalars['String']>;
};

/** Topic selection for course. Allows the user to select more then one course */
export type Topic = Node & {
  __typename?: 'Topic';
  /** Description of the topic */
  description: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Auto generated id for topic */
  topicId: Scalars['Int'];
};

/** A connection to a list of items. */
export type TopicConnection = {
  __typename?: 'TopicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TopicEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopicEdge = {
  __typename?: 'TopicEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Topic>;
};

/** Representation of admin user data. */
export type UnconfirmedAdminUser = {
  __typename?: 'UnconfirmedAdminUser';
  /** E-Mail address. */
  email: Scalars['Email'];
  /** First name. */
  firstName: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** Is user deleted. */
  isDeleted: Scalars['Boolean'];
  /** Is user a super user (Admin). */
  isSuperUser: Scalars['Boolean'];
  /** Last name. */
  lastName: Scalars['String'];
};

export type UpdateAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  eoAllCampuses?: InputMaybe<Scalars['Boolean']>;
  eoAllSubjects?: InputMaybe<Scalars['Boolean']>;
  eoCampusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eoSubjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  permissions?: InputMaybe<Array<InputMaybe<AdminFeatures>>>;
};

export type UpdateAdminUserPayload = {
  __typename?: 'UpdateAdminUserPayload';
  adminUser?: Maybe<AdminUserOutput>;
  clientMutationId?: Maybe<Scalars['String']>;
  environment?: Maybe<Environment>;
  error?: Maybe<MutationError>;
};

export type UpdateProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<MutationError>;
  user?: Maybe<AdminUserOutput>;
  viewer?: Maybe<ActiveUser>;
};

export type UploadStudentIdsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** List of student IDs */
  studentIdList?: InputMaybe<Scalars['String']>;
};

export type UploadStudentIdsPayload = {
  __typename?: 'UploadStudentIdsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<MutationError>;
  studentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Public Customization Center Settings */
export type PublicSettings = {
  __typename?: 'publicSettings';
  /** Course Search Settings */
  courseSearchSettings?: Maybe<CourseSearchSettings>;
  /** Course Settings */
  courseSettings?: Maybe<PublicCourseSettings>;
  /** Custom Header Link Text Setting */
  customLinkText?: Maybe<Scalars['String']>;
  /** Custom Header Link URL Setting */
  customLinkUrl?: Maybe<Scalars['String']>;
  /** Filter Settings */
  filterSettings?: Maybe<FilterSettings>;
  /** Help Settings */
  helpSettings?: Maybe<HelpSettings>;
  /** Help Text Setting */
  helpText?: Maybe<Scalars['String']>;
  /** Help URL Settings */
  helpUrl?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Section Field Text Settings */
  sectionFieldTextSettings?: Maybe<SectionFieldTextSettings>;
  /** Section Settings */
  sectionSettings?: Maybe<SectionSettings>;
  /** Security Settings */
  securitySettings?: Maybe<SecuritySettings>;
  /** Style Settings */
  styleSettings?: Maybe<StyleSettings>;
  /** Text Settings */
  textSettings?: Maybe<TextSettings>;
};

/** Customization Center Settings */
export type Settings = Node & {
  __typename?: 'settings';
  /** Academic Planning Settings */
  academicPlanningSettings?: Maybe<AcademicPlanningSettings>;
  /** Admin Settings */
  adminSettings?: Maybe<AdminSettings>;
  /** Course Settings */
  courseSettings?: Maybe<CourseSettings>;
  /** Filter Settings */
  filterSettings?: Maybe<FilterSettings>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Section Field Text Settings */
  sectionFieldTextSettings?: Maybe<SectionFieldTextSettings>;
  /** Section Settings */
  sectionSettings?: Maybe<SectionSettings>;
  /** Security Settings */
  securitySettings?: Maybe<SecuritySettings>;
  /** SIS Settings */
  sisSettings?: Maybe<SisSettings>;
  /** SIS Type */
  sisType?: Maybe<Scalars['String']>;
  /** Style Settings */
  styleSettings?: Maybe<StyleSettings>;
  /** Text Settings */
  textSettings?: Maybe<TextSettings>;
};

export type SearchSectionTextFragment = { __typename?: 'SectionFieldTextSettings', campus?: string | null, component?: string | null, credits?: string | null, dates?: string | null, days?: string | null, instructionMode?: string | null, instructorPlural?: string | null, location?: string | null, openSeats?: string | null, registrationNumber?: string | null, rooms?: string | null, times?: string | null };

export type SearchSettingsFragment = { __typename?: 'publicSettings', courseSearchSettings?: { __typename?: 'CourseSearchSettings', courseSearchFilters?: Array<string | null> | null, sectionFields?: Array<string | null> | null } | null, sectionFieldTextSettings?: { __typename?: 'SectionFieldTextSettings', campus?: string | null, component?: string | null, credits?: string | null, dates?: string | null, days?: string | null, instructionMode?: string | null, instructorPlural?: string | null, location?: string | null, openSeats?: string | null, registrationNumber?: string | null, rooms?: string | null, times?: string | null } | null, textSettings?: { __typename?: 'TextSettings', campus?: string | null, campusPlural?: string | null, courseStatus?: string | null, instructionModePlural?: string | null, instructor?: string | null, locationPlural?: string | null, sectionPlural?: string | null } | null };

export type HomeTermFragment = { __typename?: 'SearchTerm', id: string, code: string, name: string };

export type SearchHomeQueryVariables = Exact<{
  environment: Scalars['String'];
}>;


export type SearchHomeQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', courseSearchTerms?: Array<{ __typename?: 'SearchTerm', id: string, code: string, name: string } | null> | null, publicSettings?: { __typename?: 'publicSettings', courseSearchSettings?: { __typename?: 'CourseSearchSettings', courseSearchFilters?: Array<string | null> | null, sectionFields?: Array<string | null> | null } | null, sectionFieldTextSettings?: { __typename?: 'SectionFieldTextSettings', campus?: string | null, component?: string | null, credits?: string | null, dates?: string | null, days?: string | null, instructionMode?: string | null, instructorPlural?: string | null, location?: string | null, openSeats?: string | null, registrationNumber?: string | null, rooms?: string | null, times?: string | null } | null, textSettings?: { __typename?: 'TextSettings', campus?: string | null, campusPlural?: string | null, courseStatus?: string | null, instructionModePlural?: string | null, instructor?: string | null, locationPlural?: string | null, sectionPlural?: string | null } | null } | null } | null };

export type SearchCourseFragment = { __typename?: 'SearchCourse', id: string, courseNumber?: string | null, externalCourseId?: string | null, title?: string | null, description?: string | null, creditsMin?: number | null, creditsMax?: number | null, subject?: { __typename?: 'SearchSubject', id: string } | null, term?: { __typename?: 'SearchTerm', code: string } | null };

export type SearchSectionMeetingFragment = { __typename?: 'SearchSectionMeeting', room?: string | null, building?: string | null, buildingCode?: string | null, buildingDescription?: string | null, days?: string | null, startDate?: any | null, endDate?: any | null, startTime?: number | null, endTime?: number | null };

export type SearchSectionFragment = { __typename?: 'SearchSection', id: string, campus?: string | null, component?: string | null, courseOfferNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, endDate?: any | null, instructionMode?: string | null, instructors?: Array<string | null> | null, location?: string | null, openSeats?: number | null, registrationNumber: string, sectionNumber?: string | null, startDate?: any | null, totalSeats?: number | null, meetings?: Array<{ __typename?: 'SearchSectionMeeting', room?: string | null, building?: string | null, buildingCode?: string | null, buildingDescription?: string | null, days?: string | null, startDate?: any | null, endDate?: any | null, startTime?: number | null, endTime?: number | null } | null> | null };

export type FindSearchSectionQueryVariables = Exact<{
  courseId: Scalars['ID'];
  sectionId: Scalars['ID'];
}>;


export type FindSearchSectionQuery = { __typename?: 'RootQuery', course?: { __typename?: 'ActiveUser' } | { __typename?: 'AdminUser' } | { __typename?: 'Course' } | { __typename?: 'Environment' } | { __typename?: 'PreloaderHistory' } | { __typename?: 'ReportTerm' } | { __typename?: 'SearchCourse', id: string, courseNumber?: string | null, externalCourseId?: string | null, title?: string | null, description?: string | null, creditsMin?: number | null, creditsMax?: number | null, subject?: { __typename?: 'SearchSubject', id: string } | null, term?: { __typename?: 'SearchTerm', code: string } | null } | { __typename?: 'SearchSection' } | { __typename?: 'SearchTerm' } | { __typename?: 'Subject' } | { __typename?: 'Term' } | { __typename?: 'Topic' } | { __typename?: 'settings' } | null, section?: { __typename?: 'ActiveUser' } | { __typename?: 'AdminUser' } | { __typename?: 'Course' } | { __typename?: 'Environment' } | { __typename?: 'PreloaderHistory' } | { __typename?: 'ReportTerm' } | { __typename?: 'SearchCourse' } | { __typename?: 'SearchSection', id: string, campus?: string | null, component?: string | null, courseOfferNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, endDate?: any | null, instructionMode?: string | null, instructors?: Array<string | null> | null, location?: string | null, openSeats?: number | null, registrationNumber: string, sectionNumber?: string | null, startDate?: any | null, totalSeats?: number | null, meetings?: Array<{ __typename?: 'SearchSectionMeeting', room?: string | null, building?: string | null, buildingCode?: string | null, buildingDescription?: string | null, days?: string | null, startDate?: any | null, endDate?: any | null, startTime?: number | null, endTime?: number | null } | null> | null } | { __typename?: 'SearchTerm' } | { __typename?: 'Subject' } | { __typename?: 'Term' } | { __typename?: 'Topic' } | { __typename?: 'settings' } | null };

export type FindSearchCourseQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type FindSearchCourseQuery = { __typename?: 'RootQuery', course?: { __typename?: 'ActiveUser' } | { __typename?: 'AdminUser' } | { __typename?: 'Course' } | { __typename?: 'Environment' } | { __typename?: 'PreloaderHistory' } | { __typename?: 'ReportTerm' } | { __typename?: 'SearchCourse', id: string, courseNumber?: string | null, externalCourseId?: string | null, title?: string | null, description?: string | null, creditsMin?: number | null, creditsMax?: number | null, subject?: { __typename?: 'SearchSubject', id: string } | null, term?: { __typename?: 'SearchTerm', code: string } | null } | { __typename?: 'SearchSection' } | { __typename?: 'SearchTerm' } | { __typename?: 'Subject' } | { __typename?: 'Term' } | { __typename?: 'Topic' } | { __typename?: 'settings' } | null };

export type FacetResultsFragment = { __typename?: 'SearchFacetFieldResult', facetField: SearchFacetField, facetFieldValueResults?: Array<{ __typename?: 'SearchFacetFieldValueResult', value: string, selected: boolean, sectionCount: number } | null> | null };

export type SearchCourseConnectionFragment = { __typename?: 'SearchCourseConnection', edges?: Array<{ __typename?: 'SearchCourseEdge', node?: { __typename?: 'SearchCourse', id: string, courseNumber?: string | null, externalCourseId?: string | null, title?: string | null, description?: string | null, creditsMin?: number | null, creditsMax?: number | null, subject?: { __typename?: 'SearchSubject', id: string } | null, term?: { __typename?: 'SearchTerm', code: string } | null } | null } | null> | null };

export type FindManySearchCoursesQueryVariables = Exact<{
  environment: Scalars['String'];
  termCode: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  facets?: InputMaybe<Array<InputMaybe<SearchFacetCriteria>> | InputMaybe<SearchFacetCriteria>>;
  includeFullCourses?: InputMaybe<Scalars['Boolean']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  freeTextbook?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindManySearchCoursesQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', findCourses?: { __typename?: 'SearchCourseConnection', totalSections: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, facetFieldResults?: Array<{ __typename?: 'SearchFacetFieldResult', facetField: SearchFacetField, facetFieldValueResults?: Array<{ __typename?: 'SearchFacetFieldValueResult', value: string, selected: boolean, sectionCount: number } | null> | null } | null> | null, edges?: Array<{ __typename?: 'SearchCourseEdge', node?: { __typename?: 'SearchCourse', id: string, courseNumber?: string | null, externalCourseId?: string | null, title?: string | null, description?: string | null, creditsMin?: number | null, creditsMax?: number | null, subject?: { __typename?: 'SearchSubject', id: string } | null, term?: { __typename?: 'SearchTerm', code: string } | null } | null } | null> | null } | null } | null };

export type SearchSectionConnectionFragment = { __typename?: 'SearchSectionConnection', edges?: Array<{ __typename?: 'SearchSectionEdge', node?: { __typename?: 'SearchSection', id: string, campus?: string | null, component?: string | null, courseOfferNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, endDate?: any | null, instructionMode?: string | null, instructors?: Array<string | null> | null, location?: string | null, openSeats?: number | null, registrationNumber: string, sectionNumber?: string | null, startDate?: any | null, totalSeats?: number | null, meetings?: Array<{ __typename?: 'SearchSectionMeeting', room?: string | null, building?: string | null, buildingCode?: string | null, buildingDescription?: string | null, days?: string | null, startDate?: any | null, endDate?: any | null, startTime?: number | null, endTime?: number | null } | null> | null } | null } | null> | null };

export type FindManySearchSectionsQueryVariables = Exact<{
  environment: Scalars['String'];
  courseId: Scalars['ID'];
  count?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  facets?: InputMaybe<Array<InputMaybe<SearchFacetCriteria>> | InputMaybe<SearchFacetCriteria>>;
  includeFullCourses?: InputMaybe<Scalars['Boolean']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  freeTextbook?: InputMaybe<Scalars['Boolean']>;
  instructor?: InputMaybe<Scalars['String']>;
}>;


export type FindManySearchSectionsQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', getCourseSections?: { __typename?: 'SearchSectionConnection', totalSections: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, facetFieldResults?: Array<{ __typename?: 'SearchFacetFieldResult', facetField: SearchFacetField, facetFieldValueResults?: Array<{ __typename?: 'SearchFacetFieldValueResult', value: string, selected: boolean, sectionCount: number } | null> | null } | null> | null, edges?: Array<{ __typename?: 'SearchSectionEdge', node?: { __typename?: 'SearchSection', id: string, campus?: string | null, component?: string | null, courseOfferNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, endDate?: any | null, instructionMode?: string | null, instructors?: Array<string | null> | null, location?: string | null, openSeats?: number | null, registrationNumber: string, sectionNumber?: string | null, startDate?: any | null, totalSeats?: number | null, meetings?: Array<{ __typename?: 'SearchSectionMeeting', room?: string | null, building?: string | null, buildingCode?: string | null, buildingDescription?: string | null, days?: string | null, startDate?: any | null, endDate?: any | null, startTime?: number | null, endTime?: number | null } | null> | null } | null } | null> | null } | null } | null };

export type FindInstructorSearchCoursesQueryVariables = Exact<{
  environment: Scalars['String'];
  termCode: Scalars['String'];
  count?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  facets?: InputMaybe<Array<InputMaybe<SearchFacetCriteria>> | InputMaybe<SearchFacetCriteria>>;
  includeFullCourses?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindInstructorSearchCoursesQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', findCourses?: { __typename?: 'SearchCourseConnection', totalSections: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, facetFieldResults?: Array<{ __typename?: 'SearchFacetFieldResult', facetField: SearchFacetField, facetFieldValueResults?: Array<{ __typename?: 'SearchFacetFieldValueResult', value: string, selected: boolean, sectionCount: number } | null> | null } | null> | null, edges?: Array<{ __typename?: 'SearchCourseEdge', node?: { __typename?: 'SearchCourse', id: string, courseNumber?: string | null, externalCourseId?: string | null, title?: string | null, description?: string | null, creditsMin?: number | null, creditsMax?: number | null, subject?: { __typename?: 'SearchSubject', id: string } | null, term?: { __typename?: 'SearchTerm', code: string } | null } | null } | null> | null } | null } | null };

export type SuggestCourseDataFragment = { __typename?: 'SearchSuggestResultCourse', courseId: string, courseNumber: string, subjectId: string, title: string };

export type SuggestCoursesQueryVariables = Exact<{
  environment: Scalars['String'];
  termCode: Scalars['String'];
  prefix: Scalars['String'];
}>;


export type SuggestCoursesQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', courses?: Array<{ __typename?: 'SearchSuggestResultCourse', courseId: string, courseNumber: string, subjectId: string, title: string } | null> | null } | null };

export type CourseSearchTermsQueryVariables = Exact<{
  environment: Scalars['String'];
}>;


export type CourseSearchTermsQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', courseSearchTerms?: Array<{ __typename?: 'SearchTerm', id: string, code: string, name: string } | null> | null } | null };

export type StyleSettingsQueryVariables = Exact<{
  environment: Scalars['String'];
}>;


export type StyleSettingsQuery = { __typename?: 'RootQuery', environment?: { __typename?: 'Environment', publicSettings?: { __typename?: 'publicSettings', styleSettings?: { __typename?: 'StyleSettings', logoUrl?: string | null, navbarColor?: string | null, primaryColor?: string | null } | null } | null } | null };

export const SearchSectionTextFragmentDoc = gql`
    fragment searchSectionText on SectionFieldTextSettings {
  campus
  component
  credits
  dates
  days
  instructionMode
  instructorPlural
  location
  openSeats
  registrationNumber
  rooms
  times
}
    `;
export const SearchSettingsFragmentDoc = gql`
    fragment searchSettings on publicSettings {
  courseSearchSettings {
    courseSearchFilters
    sectionFields
  }
  sectionFieldTextSettings {
    ...searchSectionText
  }
  textSettings {
    campus
    campusPlural
    courseStatus
    instructionModePlural
    instructor
    locationPlural
    sectionPlural
  }
}
    ${SearchSectionTextFragmentDoc}`;
export const HomeTermFragmentDoc = gql`
    fragment homeTerm on SearchTerm {
  id
  code
  name
}
    `;
export const FacetResultsFragmentDoc = gql`
    fragment facetResults on SearchFacetFieldResult {
  facetField
  facetFieldValueResults {
    value
    selected
    sectionCount
  }
}
    `;
export const SearchCourseFragmentDoc = gql`
    fragment searchCourse on SearchCourse {
  id
  courseNumber
  externalCourseId
  title
  subject {
    id
  }
  term {
    code
  }
  courseNumber
  title
  description
  creditsMin
  creditsMax
}
    `;
export const SearchCourseConnectionFragmentDoc = gql`
    fragment searchCourseConnection on SearchCourseConnection {
  edges {
    node {
      id
      ...searchCourse
    }
  }
}
    ${SearchCourseFragmentDoc}`;
export const SearchSectionMeetingFragmentDoc = gql`
    fragment searchSectionMeeting on SearchSectionMeeting {
  room
  building
  buildingCode
  buildingDescription
  days
  startDate
  endDate
  startTime
  endTime
}
    `;
export const SearchSectionFragmentDoc = gql`
    fragment searchSection on SearchSection {
  id
  campus
  component
  courseOfferNumber
  creditsMax
  creditsMin
  endDate
  instructionMode
  instructors
  location
  openSeats
  registrationNumber
  sectionNumber
  startDate
  totalSeats
  meetings {
    ...searchSectionMeeting
  }
}
    ${SearchSectionMeetingFragmentDoc}`;
export const SearchSectionConnectionFragmentDoc = gql`
    fragment searchSectionConnection on SearchSectionConnection {
  edges {
    node {
      id
      ...searchSection
    }
  }
}
    ${SearchSectionFragmentDoc}`;
export const SuggestCourseDataFragmentDoc = gql`
    fragment suggestCourseData on SearchSuggestResultCourse {
  courseId
  courseNumber
  subjectId
  title
}
    `;
export const SearchHomeDocument = gql`
    query searchHome($environment: String!) {
  environment(name: $environment) {
    courseSearchTerms {
      ...homeTerm
    }
    publicSettings {
      ...searchSettings
    }
  }
}
    ${HomeTermFragmentDoc}
${SearchSettingsFragmentDoc}`;

/**
 * __useSearchHomeQuery__
 *
 * To run a query within a React component, call `useSearchHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchHomeQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useSearchHomeQuery(baseOptions: Apollo.QueryHookOptions<SearchHomeQuery, SearchHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchHomeQuery, SearchHomeQueryVariables>(SearchHomeDocument, options);
      }
export function useSearchHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchHomeQuery, SearchHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchHomeQuery, SearchHomeQueryVariables>(SearchHomeDocument, options);
        }
export type SearchHomeQueryHookResult = ReturnType<typeof useSearchHomeQuery>;
export type SearchHomeLazyQueryHookResult = ReturnType<typeof useSearchHomeLazyQuery>;
export type SearchHomeQueryResult = Apollo.QueryResult<SearchHomeQuery, SearchHomeQueryVariables>;
export const FindSearchSectionDocument = gql`
    query findSearchSection($courseId: ID!, $sectionId: ID!) {
  course: node(id: $courseId) {
    ...searchCourse
  }
  section: node(id: $sectionId) {
    ...searchSection
  }
}
    ${SearchCourseFragmentDoc}
${SearchSectionFragmentDoc}`;

/**
 * __useFindSearchSectionQuery__
 *
 * To run a query within a React component, call `useFindSearchSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSearchSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSearchSectionQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useFindSearchSectionQuery(baseOptions: Apollo.QueryHookOptions<FindSearchSectionQuery, FindSearchSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSearchSectionQuery, FindSearchSectionQueryVariables>(FindSearchSectionDocument, options);
      }
export function useFindSearchSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSearchSectionQuery, FindSearchSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSearchSectionQuery, FindSearchSectionQueryVariables>(FindSearchSectionDocument, options);
        }
export type FindSearchSectionQueryHookResult = ReturnType<typeof useFindSearchSectionQuery>;
export type FindSearchSectionLazyQueryHookResult = ReturnType<typeof useFindSearchSectionLazyQuery>;
export type FindSearchSectionQueryResult = Apollo.QueryResult<FindSearchSectionQuery, FindSearchSectionQueryVariables>;
export const FindSearchCourseDocument = gql`
    query findSearchCourse($courseId: ID!) {
  course: node(id: $courseId) {
    ...searchCourse
  }
}
    ${SearchCourseFragmentDoc}`;

/**
 * __useFindSearchCourseQuery__
 *
 * To run a query within a React component, call `useFindSearchCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSearchCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSearchCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useFindSearchCourseQuery(baseOptions: Apollo.QueryHookOptions<FindSearchCourseQuery, FindSearchCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSearchCourseQuery, FindSearchCourseQueryVariables>(FindSearchCourseDocument, options);
      }
export function useFindSearchCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSearchCourseQuery, FindSearchCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSearchCourseQuery, FindSearchCourseQueryVariables>(FindSearchCourseDocument, options);
        }
export type FindSearchCourseQueryHookResult = ReturnType<typeof useFindSearchCourseQuery>;
export type FindSearchCourseLazyQueryHookResult = ReturnType<typeof useFindSearchCourseLazyQuery>;
export type FindSearchCourseQueryResult = Apollo.QueryResult<FindSearchCourseQuery, FindSearchCourseQueryVariables>;
export const FindManySearchCoursesDocument = gql`
    query findManySearchCourses($environment: String!, $termCode: String!, $query: String, $count: Int, $cursor: String, $facets: [SearchFacetCriteria], $includeFullCourses: Boolean, $registrationNumber: String, $freeTextbook: Boolean) {
  environment(name: $environment) {
    findCourses(
      termCode: $termCode
      query: $query
      first: $count
      after: $cursor
      facets: $facets
      includeFullCourses: $includeFullCourses
      registrationNumber: $registrationNumber
      freeTextbook: $freeTextbook
    ) @connection(key: "search_courses", filter: ["termCode", "query", "registrationNumber", "includeFullCourses", "freeTextbook", "facets"]) {
      totalSections
      pageInfo {
        endCursor
        hasNextPage
      }
      facetFieldResults {
        ...facetResults
      }
      ...searchCourseConnection
    }
  }
}
    ${FacetResultsFragmentDoc}
${SearchCourseConnectionFragmentDoc}`;

/**
 * __useFindManySearchCoursesQuery__
 *
 * To run a query within a React component, call `useFindManySearchCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySearchCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySearchCoursesQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *      termCode: // value for 'termCode'
 *      query: // value for 'query'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *      facets: // value for 'facets'
 *      includeFullCourses: // value for 'includeFullCourses'
 *      registrationNumber: // value for 'registrationNumber'
 *      freeTextbook: // value for 'freeTextbook'
 *   },
 * });
 */
export function useFindManySearchCoursesQuery(baseOptions: Apollo.QueryHookOptions<FindManySearchCoursesQuery, FindManySearchCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySearchCoursesQuery, FindManySearchCoursesQueryVariables>(FindManySearchCoursesDocument, options);
      }
export function useFindManySearchCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySearchCoursesQuery, FindManySearchCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySearchCoursesQuery, FindManySearchCoursesQueryVariables>(FindManySearchCoursesDocument, options);
        }
export type FindManySearchCoursesQueryHookResult = ReturnType<typeof useFindManySearchCoursesQuery>;
export type FindManySearchCoursesLazyQueryHookResult = ReturnType<typeof useFindManySearchCoursesLazyQuery>;
export type FindManySearchCoursesQueryResult = Apollo.QueryResult<FindManySearchCoursesQuery, FindManySearchCoursesQueryVariables>;
export const FindManySearchSectionsDocument = gql`
    query findManySearchSections($environment: String!, $courseId: ID!, $count: Int, $cursor: String, $facets: [SearchFacetCriteria], $includeFullCourses: Boolean, $registrationNumber: String, $freeTextbook: Boolean, $instructor: String) {
  environment(name: $environment) {
    getCourseSections(
      courseId: $courseId
      first: $count
      after: $cursor
      facets: $facets
      includeFullSections: $includeFullCourses
      registrationNumber: $registrationNumber
      freeTextbook: $freeTextbook
      instructor: $instructor
    ) @connection(key: "search_sections", filter: ["courseId", "registrationNumber", "includeFullSections", "freeTextbook", "facets", "instructor"]) {
      totalSections
      pageInfo {
        endCursor
        hasNextPage
      }
      facetFieldResults {
        ...facetResults
      }
      ...searchSectionConnection
    }
  }
}
    ${FacetResultsFragmentDoc}
${SearchSectionConnectionFragmentDoc}`;

/**
 * __useFindManySearchSectionsQuery__
 *
 * To run a query within a React component, call `useFindManySearchSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySearchSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySearchSectionsQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *      courseId: // value for 'courseId'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *      facets: // value for 'facets'
 *      includeFullCourses: // value for 'includeFullCourses'
 *      registrationNumber: // value for 'registrationNumber'
 *      freeTextbook: // value for 'freeTextbook'
 *      instructor: // value for 'instructor'
 *   },
 * });
 */
export function useFindManySearchSectionsQuery(baseOptions: Apollo.QueryHookOptions<FindManySearchSectionsQuery, FindManySearchSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySearchSectionsQuery, FindManySearchSectionsQueryVariables>(FindManySearchSectionsDocument, options);
      }
export function useFindManySearchSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySearchSectionsQuery, FindManySearchSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySearchSectionsQuery, FindManySearchSectionsQueryVariables>(FindManySearchSectionsDocument, options);
        }
export type FindManySearchSectionsQueryHookResult = ReturnType<typeof useFindManySearchSectionsQuery>;
export type FindManySearchSectionsLazyQueryHookResult = ReturnType<typeof useFindManySearchSectionsLazyQuery>;
export type FindManySearchSectionsQueryResult = Apollo.QueryResult<FindManySearchSectionsQuery, FindManySearchSectionsQueryVariables>;
export const FindInstructorSearchCoursesDocument = gql`
    query findInstructorSearchCourses($environment: String!, $termCode: String!, $count: Int, $cursor: String, $facets: [SearchFacetCriteria], $includeFullCourses: Boolean) {
  environment(name: $environment) {
    findCourses(
      termCode: $termCode
      first: $count
      after: $cursor
      facets: $facets
      includeFullCourses: $includeFullCourses
    ) @connection(key: "instructor_courses", filter: ["termCode", "includeFullCourses", "facets"]) {
      totalSections
      pageInfo {
        endCursor
        hasNextPage
      }
      facetFieldResults {
        ...facetResults
      }
      ...searchCourseConnection
    }
  }
}
    ${FacetResultsFragmentDoc}
${SearchCourseConnectionFragmentDoc}`;

/**
 * __useFindInstructorSearchCoursesQuery__
 *
 * To run a query within a React component, call `useFindInstructorSearchCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInstructorSearchCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindInstructorSearchCoursesQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *      termCode: // value for 'termCode'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *      facets: // value for 'facets'
 *      includeFullCourses: // value for 'includeFullCourses'
 *   },
 * });
 */
export function useFindInstructorSearchCoursesQuery(baseOptions: Apollo.QueryHookOptions<FindInstructorSearchCoursesQuery, FindInstructorSearchCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindInstructorSearchCoursesQuery, FindInstructorSearchCoursesQueryVariables>(FindInstructorSearchCoursesDocument, options);
      }
export function useFindInstructorSearchCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindInstructorSearchCoursesQuery, FindInstructorSearchCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindInstructorSearchCoursesQuery, FindInstructorSearchCoursesQueryVariables>(FindInstructorSearchCoursesDocument, options);
        }
export type FindInstructorSearchCoursesQueryHookResult = ReturnType<typeof useFindInstructorSearchCoursesQuery>;
export type FindInstructorSearchCoursesLazyQueryHookResult = ReturnType<typeof useFindInstructorSearchCoursesLazyQuery>;
export type FindInstructorSearchCoursesQueryResult = Apollo.QueryResult<FindInstructorSearchCoursesQuery, FindInstructorSearchCoursesQueryVariables>;
export const SuggestCoursesDocument = gql`
    query suggestCourses($environment: String!, $termCode: String!, $prefix: String!) {
  environment(name: $environment) {
    courses: suggestCourses(termCode: $termCode, prefix: $prefix) {
      ...suggestCourseData
    }
  }
}
    ${SuggestCourseDataFragmentDoc}`;

/**
 * __useSuggestCoursesQuery__
 *
 * To run a query within a React component, call `useSuggestCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestCoursesQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *      termCode: // value for 'termCode'
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useSuggestCoursesQuery(baseOptions: Apollo.QueryHookOptions<SuggestCoursesQuery, SuggestCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestCoursesQuery, SuggestCoursesQueryVariables>(SuggestCoursesDocument, options);
      }
export function useSuggestCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestCoursesQuery, SuggestCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestCoursesQuery, SuggestCoursesQueryVariables>(SuggestCoursesDocument, options);
        }
export type SuggestCoursesQueryHookResult = ReturnType<typeof useSuggestCoursesQuery>;
export type SuggestCoursesLazyQueryHookResult = ReturnType<typeof useSuggestCoursesLazyQuery>;
export type SuggestCoursesQueryResult = Apollo.QueryResult<SuggestCoursesQuery, SuggestCoursesQueryVariables>;
export const CourseSearchTermsDocument = gql`
    query courseSearchTerms($environment: String!) {
  environment(name: $environment) {
    courseSearchTerms {
      ...homeTerm
    }
  }
}
    ${HomeTermFragmentDoc}`;

/**
 * __useCourseSearchTermsQuery__
 *
 * To run a query within a React component, call `useCourseSearchTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSearchTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSearchTermsQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useCourseSearchTermsQuery(baseOptions: Apollo.QueryHookOptions<CourseSearchTermsQuery, CourseSearchTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseSearchTermsQuery, CourseSearchTermsQueryVariables>(CourseSearchTermsDocument, options);
      }
export function useCourseSearchTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseSearchTermsQuery, CourseSearchTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseSearchTermsQuery, CourseSearchTermsQueryVariables>(CourseSearchTermsDocument, options);
        }
export type CourseSearchTermsQueryHookResult = ReturnType<typeof useCourseSearchTermsQuery>;
export type CourseSearchTermsLazyQueryHookResult = ReturnType<typeof useCourseSearchTermsLazyQuery>;
export type CourseSearchTermsQueryResult = Apollo.QueryResult<CourseSearchTermsQuery, CourseSearchTermsQueryVariables>;
export const StyleSettingsDocument = gql`
    query styleSettings($environment: String!) {
  environment(name: $environment) {
    publicSettings {
      styleSettings {
        logoUrl
        navbarColor
        primaryColor
      }
    }
  }
}
    `;

/**
 * __useStyleSettingsQuery__
 *
 * To run a query within a React component, call `useStyleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyleSettingsQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useStyleSettingsQuery(baseOptions: Apollo.QueryHookOptions<StyleSettingsQuery, StyleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyleSettingsQuery, StyleSettingsQueryVariables>(StyleSettingsDocument, options);
      }
export function useStyleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyleSettingsQuery, StyleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyleSettingsQuery, StyleSettingsQueryVariables>(StyleSettingsDocument, options);
        }
export type StyleSettingsQueryHookResult = ReturnType<typeof useStyleSettingsQuery>;
export type StyleSettingsLazyQueryHookResult = ReturnType<typeof useStyleSettingsLazyQuery>;
export type StyleSettingsQueryResult = Apollo.QueryResult<StyleSettingsQuery, StyleSettingsQueryVariables>;